import { render, staticRenderFns } from "./UIUXDesigner.vue?vue&type=template&id=33dac8e7&scoped=true&"
import script from "./UIUXDesigner.vue?vue&type=script&lang=js&"
export * from "./UIUXDesigner.vue?vue&type=script&lang=js&"
import style0 from "./UIUXDesigner.vue?vue&type=style&index=0&id=33dac8e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dac8e7",
  null
  
)

export default component.exports